<div id="no-loans-section" class="font-normal py-5" *ngIf="(loanTiles === null)">
    <img src="../../../../../assets/images/empty-folder.svg" alt="No past loan applications found"/>
    <p class="mt-4">No past loan applications found</p>
</div>

<span class="mt-4 justify-content-center align-items-center" appDottedLoader [appShowLoaderUntil]="loanTiles"></span>
<div class="pt-2">
    <div *ngFor="let tile of loanTilesObservables | async" class="tile faded font-normal mt-2 d-lg-flex d-md-flex justify-content-lg-between justify-content-md-between ng-star-inserted text-left align-items-center">
        <div class="container-fluid m-0 p-0">
            <div class="d-lg-flex d-sm-flex mb-3 loan-one-lined-details">
                <div class="mr-lg-5 mr-sm-5 font-18">
                    <span class="mr-2">Loan ID:</span>
                    <span class="font-weight-bold">{{ tile.generatedLoanId }}</span>
                </div>
                <div class="mt-3 mt-lg-0 mt-sm-0">
                    <span class="mr-2">Loan Reason:</span>
                    <span class="font-weight-bold">{{ tile.reason }}</span>
                </div>
            </div>
            <div class="d-flex flex-wrap">
                <div class="mr-5 m-0 p-0">
                    <span>₹ </span>
                    <span class="font-weight-bold">{{ tile.amount | number : '1.2-2'}}</span>
                </div>
                <div *ngIf="tile.tenure" class="mr-5 m-0 p-0">
                    <span class="font-weight-bold">for </span>
                    <span class="font-weight-bold">{{ tile.tenure }}</span><span class="font-small faded"> Months,</span>
                </div>
                <div class="m-0 p-0 mt-lg-0 mt-sm-0  mt-3 loan-one-lined-details">
                    <span class="mr-2">Application Date:</span>
                    <span class="font-weight-bold">{{ tile.applicationDate | date:'longDate' }}</span>
                </div>
            </div>
        </div>
        <div class="text-right">
            <span [ngStyle]="{'color': tile.colorCode}" class="font-xs-small font-sm-normal font-weight-bold">{{ tile.status }}</span>
        </div>
    </div>
    <div class="mt-4"  *ngIf="dataSource?.data?.length > defaultPageSize">
        <app-pagination [dataSource]="dataSource" [length]="dataSource.data.length" [pageSize]="defaultPageSize" [showTotalPages]="4"
                        [pageSizeOptions]="[defaultPageSize, defaultPageSize * 2, defaultPageSize * 4, defaultPageSize * 10]"></app-pagination>
    </div>
</div>
